import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  onScrollToProcess: () => void;
}

const HeroSection = ({ onScrollToProcess }: HeroSectionProps) => {
  return (
    <section className="relative h-[600px] lg:h-[700px] overflow-hidden">
      <div className="absolute inset-0">
        <AppImage
          src="https://xdfjtjgomqbjrrhygnbj.supabase.co/storage/v1/object/public/FFC%20site%20images/Page5Hero1.jpg"
          alt="Modern industrial powder coating facility with large conveyor system and automated spray booths"
          className="w-full h-full object-cover"
          priority />

        <div className="absolute inset-0 bg-gradient-to-r from-primary/95 via-primary/85 to-primary/70" />
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-4 lg:px-8 flex items-center">
        <div className="max-w-3xl">
          <div className="inline-flex items-center space-x-2 px-4 py-2 backdrop-blur-sm rounded-full mb-6 bg-[rgba(255,255,255,0.102)] border-t border-b border-l border-r border-[rgba(255,255,255,0.2)]">
            <Icon name="SparklesIcon" size={20} variant="solid" className="text-accent" />
            <span className="text-sm font-cta font-semibold text-primary-foreground">
              Advanced Chemistry Protocols
            </span>
          </div>

          <h1 className="text-4xl lg:text-6xl font-headline font-bold text-primary-foreground mb-6 leading-tight">
            Powder Coating Mastery
          </h1>

          <p className="text-lg lg:text-xl mb-8 leading-relaxed text-orange-50">
            Zirconium treatment chemistry and conveyor-scale capabilities delivering superior coating performance. From pre-treatment to final cure, every step engineered for excellence.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={onScrollToProcess}
              className="inline-flex items-center justify-center space-x-2 px-8 py-4 bg-accent text-accent-foreground rounded-md font-cta font-bold hover:opacity-90 transition-all duration-base shadow-lg">

              <span>Explore Process</span>
              <Icon name="ArrowDownIcon" size={20} variant="outline" />
            </button>

            <button className="inline-flex items-center justify-center space-x-2 px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-md font-cta font-bold text-base hover:bg-white/20 transition-all duration-base border-t border-b border-l border-r">
              <Icon name="DocumentTextIcon" size={20} variant="outline" />
              <span>Chemistry Specs</span>
            </button>
          </div>

          <div className="grid grid-cols-3 gap-6 mt-12 pt-8 border-t border-primary-foreground/20">
            <div>
              <div className="text-3xl font-headline font-bold text-accent mb-1">99.8%</div>
              <div className="text-sm text-white font-body drop-shadow-sm">First-Pass Quality</div>
            </div>
            <div>
              <div className="text-3xl font-headline font-bold text-accent mb-1">1000+</div>
              <div className="text-sm text-white font-body drop-shadow-sm">Hours Salt Spray</div>
            </div>
            <div>
              <div className="text-3xl font-headline font-bold text-accent mb-1">24/7</div>
              <div className="text-sm text-white font-body drop-shadow-sm">Conveyor Operation</div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;